import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useActionBarResponsiveClasses } from './useActionBarResponsiveClasses';

export enum ActionBarInteractionTrigger {
    CLICK = 'click',
    HOVER = 'hover',
}

interface ActionBarShellProps {
    children?: ReactNode;
}

export function ActionBarShell({ children }: ActionBarShellProps) {
    const responsive = useActionBarResponsiveClasses();
    return (
        <div
            className={cn(
                'h-10 bg-grey-600 border border-grey-600 rounded-full flex items-center pr-1 py-1 gap-3',
                responsive.shellPadding,
            )}
        >
            {children}
        </div>
    );
}
